<template>
  <div class="row">
    <div class="col-md-12">
      <div class="section privacy">
        <div class="section-header text-uppercase profile-header">{{ $t('PROFILE.notification.privacy.title')}}</div>
          <div class="section-content">
            <!-- inverted toggle function -->
            <switcher :value="!account.activityPrivacy" :name="'privacy'" @input="onPrivacyChange"></switcher>
            <div class="control-label-default checkbox-text">
              <p>{{ $t('PROFILE.notification.privacy.visibleSessions')}}</p>
            </div>
        </div>
        <div class="section-content">
            <!-- inverted toggle function -->
            <switcher :value="!account.systemWideActivityPrivacy" :name="'systemWidePrivacy'" @input="onSystemWidePrivacyChange"></switcher>
            <div class="control-label-default checkbox-text">
              <p>{{ $t('PROFILE.notification.privacy.systemWidePrivacy')}}</p>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TOASTER_SUCCESS, TOASTER_ERROR } from '@/common/events.types';
import Switcher from '@/components/common/form/Switcher';
import { mapActions } from 'vuex';
import { GET_PROFILE_DATA, UPDATE_SYSTEM_WIDE_PRIVACY } from '@/store/action.types'

export default {
  name: 'Privacy',
  props: {
    activityPrivacy : Boolean,
    playerId : Number,
    updatePrivacy : Function,
    account : Object,
    user : Object
  },
  data() {
    return {
      privacyChange: false,
      systemWidePrivacy: false
    }
  },
  methods: {
     ...mapActions({
      getProfileData: GET_PROFILE_DATA,
      updateSystemWidePrivacy : UPDATE_SYSTEM_WIDE_PRIVACY
    }),

    onPrivacyChange () {
      this.privacyChange = this.account.activityPrivacy;
      this.updatePrivacy({
        playerId: this.playerId,
        privacy: !this.privacyChange
      })
      .then(() => {
        this.$eventHub.$emit(TOASTER_SUCCESS, {
          message: this.$t('PROFILE.toastMessages.privacyUpdated')
        });
        this.getProfileData(this.user.accountId)
      })
      .catch(() => {
        this.$eventHub.$emit(TOASTER_ERROR, {
          message: this.$t('TOAST_MESSAGES.errorTryAgain')
        });
      })
    },
    
    onSystemWidePrivacyChange () {
      this.systemWidePrivacy = this.account.systemWideActivityPrivacy;
      this.updateSystemWidePrivacy({
        playerId: this.playerId,
        privacy: !this.systemWidePrivacy
      })
      .then(() => {
        this.$eventHub.$emit(TOASTER_SUCCESS, {
          message: this.$t('PROFILE.toastMessages.privacyUpdated')
        });
        this.getProfileData(this.user.accountId)
      })
      .catch(() => {
        this.$eventHub.$emit(TOASTER_ERROR, {
          message: this.$t('TOAST_MESSAGES.errorTryAgain')
        });
      })
    }
  },
  components: {
    Switcher
  }
}
</script>

<style lang="scss" scoped>
  .switcher-wrapper {
    vertical-align: top;
    margin-top: 7px;
  }

  .section {
    margin-top: 0;
  }

  .section-content {
    min-height: 0;
  }

  .control-label-default {
    display: inline-block;
    margin-left: 20px;
    width: calc(100% - 60px);
  }
</style>
